/** Extension of Time (M32015) 문서 provide/inject 컨텍스트. */
import type { InjectionKey, Ref } from 'vue';
import type { ExtensionOfTimeFieldType } from './extensionOfTimeFields';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface ExtensionOfTimeDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => ExtensionOfTimeFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;
  setFieldValue: (key: string, val: string) => void;
  openAddress: (key: string) => void;
  entityCd: Ref<string>;
  signersOf: (varKey: string) => SignerEntry[];
  setSigners: (varKey: string, list: SignerEntry[]) => void;
  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;

  /** [[if X]] 조건 토글 */
  flag: (name: string) => boolean;
  toggleFlag: (name: string) => void;
  /** resolution_basis / company_type */
  choiceOf: (name: string) => string;
  setChoice: (name: string, val: string) => void;
}

export const EXTENSION_OF_TIME_DOC_CTX: InjectionKey<ExtensionOfTimeDocContext> = Symbol('extensionOfTimeDocCtx');
